/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Work } from './Work';
const ExtendedWorkParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['isLatest', codecBoolean, 'is_latest']]), Work);
export class ExtendedWork extends Work {
    static decode(input) {
        return ExtendedWorkParser.decode(input).map(res => new ExtendedWork(res));
    }
    static unsafeDecode(input) {
        return ExtendedWork.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedWorkParser.encode(data);
    }
    static schema() {
        return ExtendedWorkParser.schema();
    }
}
